export class Translation {
    constructor(_NL: string, _FR: string) {
        this.NL = _NL;
        this.FR = _FR;        
    }
    public NL: String;
    public FR: String;
}